<div class="form-group d-inline-block" ngbDropdown #calendarPanel="ngbDropdown" (openChange)="$event && open()">
  <div class="d-flex flex-column justify-content-start w-100">
    <div class="input-group inputDiv">
      <input
        type="text"
        style="border: none;"
        (keydown.arrowdown)="calendar.open()"
        class="form-control"
        id="data"
        name="data"
        [maxLength]="7"
        [(ngModel)]="dataTxt"
        [placeholder]="mask"
        #item
        (input)="change(item.value)"
        [class.has-error]="validationError && (!dataTxt || invalidDate)"
      />
      <div class="input-group-append">

        <button class="btn btn-outline-secondary  dropdown-toggle-split" style="padding: 0.6em;border: none;" ngbDropdownToggle>
          <div class="calendar" aria-hidden="true"></div>
        </button>
      </div>
    </div>
    <span class="error-text" *ngIf="validationError && !dataTxt" style="margin-top: 0.8rem; margin-left: 0.4rem;">Business Established Date is required</span>
    <span class="error-text" *ngIf="validationError && dataTxt && invalidDate">Please enter valid business established date</span>
  </div>

  <div ngbDropdownMenu class="dropdown-menu">
    <div class="wrap-container">
      <div class="btn-first">
        <button
          [disabled]="minDate && (!isyear ? displayYear <= minDate.year : initialYear < minDate.year)"
          #btn
          class="btn btn-link"
          (click)="addYear(-1)"
        >
          <span class="ngb-dp-navigation-arrow left"></span>
        </button>
      </div>
      <div class="item-center">
        <button #btn class="btn btn-link" (click)="showYear(!isyear)">
          {{ !isyear ? displayYear : initialYear + '-' + (initialYear + 11) }}
        </button>
      </div>
      <div class="btn-last">
        <button class="btn btn-link" (click)="addYear(+1)">
          <span class="ngb-dp-navigation-arrow right"></span>
        </button>
      </div>
    </div>
    <div class="wrap-container" (keydown)="onKeyDown($event)">
      <div class="item" *ngFor="let month of months; let i = index" (click)="cellsSelectables[i] && selectYearMonth(i)">
        <div
          *ngIf="isyear"
          #cell
          class="outline-none"
          [tabindex]="i + initialYear == displayYear ? 4 : -1"
          [attr.data-year]="i + initialYear"
          [class.selectable]="cellsSelectables[i]"
        >
          <ng-container
            *ngTemplateOutlet="
              templateData ? templateData : templateDef;
              context: {
                $implicit: i + initialYear,
                selected: i + initialYear == displayYear
              }
            "
          >
          </ng-container>
        </div>
        <div
          *ngIf="!isyear"
          #cell
          class="outline-none"
          [tabindex]="i + 1 == displayMonth ? 0 : -1"
          [attr.data-month]="i + 1"
          [class.selectable]="cellsSelectables[i]"
        >
          <ng-container
            *ngTemplateOutlet="
              templateData ? templateData : templateDef;
              context: { $implicit: month, selected: i + 1 == displayMonth }
            "
          >
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #template let-data let-selected="selected">
  <div class="cell-body" [ngClass]="selected ? 'btn-primary selected' : null">
    <span>{{ data }}</span>
  </div>
</ng-template>
